import { render, staticRenderFns } from "./BundleBreakdown.vue?vue&type=template&id=11e7e527&"
import script from "./BundleBreakdown.vue?vue&type=script&lang=js&"
export * from "./BundleBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports